<template>
  <div class="process" @click="$bus.addGA('process', 'click')">
    <div class="process-inner">
      <div class="process-node">
        <div class="process-node-item" :class="$bus.selects.length > index + 1 && !$bus.ComPool.status ? 'active-clock' : ''" v-for="(item, index) in $bus.actInfo.discounts" :key="item"></div>
      </div>
      <div class="process-main" :style="{width: getProcess}">
        <i class="process-star" v-show="$bus.selects.length > 0 && !this.$bus.ComPool.status"></i>
      </div>
    </div>
    <div class="process-percent">
      <div class="process-percent-item" v-for="item in $bus.actInfo.discounts" :key="item">
        <span>{{item}}%</span><span>&nbsp;&nbsp;{{$bus.transify['T_P_OFF']}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getProcess () {
      if (!this.$bus.ComPool.status) {
        switch (this.$bus.selects.length) {
          case 1:
            return '33.16%'
          case 2:
            return '66.46%'
          case 3:
            return '100%'
          default:
            return '0'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.process {
  position: relative;
  @include px2res(width, 1230);
  margin: 0 auto;
  .process-inner {
    @include px2res(height, 24);
    width: 100%;
    position: relative;
    .process-node {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      .process-node-item {
        @include px2res(width, 2);
        @include px2res(height, 24);
        background-color: #FFFDF6;
        position: absolute;
        z-index: 1;
        box-shadow: 0 0 10px 4px rgba(255, 255, 139, .4);
        animation: twinkle .8s ease-in infinite alternate;
      }
      .process-node-item.active-clock {
        @include px2res(width, 38);
        @include px2res(height, 38);
        top: 50%;
        @include px2res(margin, -19, 0, 0, -19);
        animation: rotateA .5s ease both;
        transform: rotate(0deg);
        box-shadow: none;
        background-color: inherit;
      }
      .process-node-item:first-child {
        left: 33.18%;
      }
      .process-node-item:nth-child(2) {
        left: 66.5%;
      }
      .process-node-item:last-child {
        right: 0;
      }
    }
    .process-main {
      @include px2res(max-width, 1228);
      @include px2res(height, 24);
      width: 0;
      background-size: cover;
      background-position-x: left;
      position: absolute;
      @include px2res(left, 2);
      animation: flash .8s ease-in infinite alternate, twinkle .8s ease-in infinite alternate;
      transition: width .5s ease;
      .process-star {
        @include px2res(width, 89);
        @include px2res(height, 77);
        position: absolute;
        @include px2res(right, -8);
        @include px2res(top, -30);
      }
    }
  }
  .process-percent {
    width: 100%;
    text-transform: uppercase;
    position: relative;
    @include px2res(margin-top, 8);
    @include px2res(height, 52);
    .process-percent-item {
      color: #FFDF00;
      font-style: italic;
      font-weight: 500;
      position: absolute;
      @include px2res(padding, 0, 5);
      span:first-child {
        @include px2res(font-size, 36);
        font-weight: inherit;
      }
      span:last-child {
        @include px2res(font-size, 24);
        font-weight: inherit;
      }
    }
    .process-percent-item:first-child {
      @include px2res(right, 790);
    }
    .process-percent-item:nth-child(2) {
      @include px2res(right, 380);
    }
    .process-percent-item:last-child {
      right: 0;
    }
  }
}
@keyframes twinkle {
  0% {
    box-shadow: 0 0 10px 3px rgba(255, 255, 139, .4);
  }
  100% {
    box-shadow: 0 0 10px 0 rgba(255, 255, 139, .4);
  }
}
@keyframes rotateA {
  0% {
    transform: rotate(-180deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes flash {
  0% {
    filter: brightness(.92);
  }
  100% {
    filter: brightness(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/index.vue